import { css } from '@bts-web/utils-style-engine';

export const disclaimerBannerStyles = css({
  fontSize: 'caption.small',
  lineHeight: 'caption.small',
  letterSpacing: 'caption.small',
  color: 'neutrals.text_secondary',
});

export const assetRisksLinkStyles = css({
  fontWeight: 'bold',
  color: 'neutrals.text_primary',
  textDecoration: 'underline',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: '0',
  font: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  letterSpacing: 'inherit',
});

export const disclaimerWrapperStyles = css({
  paddingX: 'medium',
  paddingY: 'extra_small',
});
